import React, { useState } from 'react';
import { getCloudId } from '@helpcenter/meta';
import { AppSwitcher } from '@atlaskit/atlassian-navigation/app-switcher';
import { Popup } from '@atlaskit/popup/popup';
import { AtlassianSwitcherLoader as AtlassianSwitcher } from '@atlassian/switcher/loaders';
import AtlassianSwitcherPrefetchTrigger from '@atlassian/switcher/prefetch-trigger';

const APP_SWITCHER_PRODUCT = 'jiraServiceManagement';

const AppSwitcherComponent = (): React.JSX.Element => {
	const [isOpen, setIsOpen] = useState(false);
	const cloudId = getCloudId();

	const onClick = () => {
		setIsOpen(!isOpen);
	};

	const onClose = () => {
		setIsOpen(false);
	};

	return (
		<Popup
			shouldRenderToParent
			placement="bottom-start"
			content={() => <AtlassianSwitcher product={APP_SWITCHER_PRODUCT} cloudId={cloudId} />}
			isOpen={isOpen}
			onClose={onClose}
			trigger={(triggerProps) => (
				<AtlassianSwitcherPrefetchTrigger cloudId={cloudId} product={APP_SWITCHER_PRODUCT}>
					<AppSwitcher onClick={onClick} tooltip="Switch to..." {...triggerProps} />
				</AtlassianSwitcherPrefetchTrigger>
			)}
		/>
	);
};

export default AppSwitcherComponent;
